import { Button, Card, CardBody, CardHeader, CardTitle, Col, FormGroup, InputGroup, Input, InputGroupAddon, Label, Row, Spinner } from "reactstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Fragment, useEffect, useState } from "react";
import Datetime from "react-datetime";
import BaseService from "../../../../../services/baseService";
import { actions as actionsSite } from "../../../../../redux/actions/site";
import Select, { components } from "react-select";
import SelectAno from "../../../../../components/Select/SelectAno/index";
import SelectUf from "../../../../../components/Select/SelectUf/index";
import { options as optionsUf } from "../../../../../components/Select/SelectUf/options";
import { cpfCnpjMask, phoneMask } from "../../../../../utils/mask";
import Error from "../../../../../components/messagesModal/error";

const baseService = new BaseService("consulta");

const Step1 = ({ values, setValues, setCurrentStep }) => {
  const dispatch = useDispatch();
  const [isSubmittingPlaca, setIsSubmittingPlaca] = useState(false);
  const [anoFabricacaoValue, setAnoFabricacaoValue] = useState();
  const [anoModeloValue, setAnoModeloValue] = useState();
  const [ufEmissaoValue, setUfEmissaoValue] = useState();
  const [dataEmissaoValue, setDataEmissaoValue] = useState();
  const [numeroViaCrvValue, setNumeroViaCrvValue] = useState();
  const [optionsNumeroViaCrv, setOptionsNumeroViaCrv] = useState([]);

  const validationSchema = Yup.object().shape({
    placa: Yup.string().required("Campo Placa é obrigatório").placaVeicular("Campo Placa é inválido"),
    renavam: Yup.string().required("Campo Renavam é obrigatório").renavamVeicular("Campo Renavam é inválido"),
    ano_fabricacao: Yup.number().required("Campo Ano Fabricação é obrigatório"),
    ano_modelo: Yup.number().required("Campo Ano Modelo é obrigatório").min(Yup.ref('ano_fabricacao'), 'Ano Modelo deve ser maior ou igual ao Ano Fabricação'),
    numero_crv: Yup.string().required("Campo Número Crv é obrigatório"),
    uf_emissao: Yup.string().required('A UF é obrigatória').uppercase().oneOf(['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'], "Campo UF de Emissão do Crv é inválido"),
    data_emissao_crv: Yup.string().required("Data Emissão Crv é obrigatório"),
    numero_via_crv: Yup.string().required("Campo Número da Via do Crv é obrigatório"),
    codigo_seguranca_crv: Yup.string().required("Campo Código Segurança Crv é obrigatório"),
    numero_identificacao_proprietario: Yup.string().required("Campo CPF/CNPJ é obrigatório").cpfCnpj("CPF/CNPJ inválido"),
    nome_proprietario: Yup.string().required("Campo Nome do Proprietário é obrigatório"),
    email_proprietario: Yup.string().required("Campo Email do Proprietário é obrigatório").email("Campo E-mail do Proprietário é inválido"),
    telefone_proprietario: Yup.string().notRequired().telefone("Telefone inválido")
  });

  const handleSetOptionsNumeroViaCrv = () => {
    let arr = [];

    for (let i = 1; i <= 10; i++) {
      arr.push({label: i, value: i})
    }

    setOptionsNumeroViaCrv(arr);
  }

  const validate = async () => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      setErrors({});
      setValues(formData);
      setCurrentStep(1);
      return true;
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
      });

      setErrors(validationErrors);

      return false;
    }
  };

  const renderInputDatePicker = (props, openCalendar) => {
    return (
      <div className="form-control datePicker d-flex justify-content-between align-items-center">
        <input {...props} name="scheduleTo" className="" readOnly style={{border:'none'}}/>
        <i className="fa-solid fa-calendar-days cursor-pointer" onClick={openCalendar} />
      </div>
    );
  };

  const Component = (props) => (
    <div style={{ border: `2px dotted #5243AA`, borderRadius: "5px", background: "#f2fcff" }}>
      <components.Group {...props} />
    </div>
  );

  const getDados = async () => {
    try {
      setIsSubmittingPlaca(true);
      const payload = { placa: formData.placa };
      await baseService._postConsulta(`${baseService.route}/veicular-proprietario-atual`, payload)
        .then((res) => {
          if (res.success) {
            const dados = res.dados;
            setFormData({
              ...formData,
              renavam: dados.renavam.padStart(11, '0'),
              ano_fabricacao: dados.ano_fabricacao,
              ano_modelo: dados.ano_modelo,
              numero_identificacao_proprietario: cpfCnpjMask(dados.documento),
              nome_proprietario: dados.nome
            });


            setAnoFabricacaoValue({ label: dados.ano_fabricacao, value: dados.ano_fabricacao });
            setAnoModeloValue({ label: dados.ano_modelo, value: dados.ano_modelo });
          } else {
            const configModal = {
              component: <Error msg={res.msg} />,
              title: `Erro`,
            };
            dispatch(actionsSite.setModal(configModal));
          }
        })
        .catch((error) => {
          if (error.response) {
            const configModal = {
              component: <Error msg={error.response.data.msg} />,
              title: `Erro`,
            };
            dispatch(actionsSite.setModal(configModal));
          }
        });
      setIsSubmittingPlaca(false);
    } catch (e) {
      console.log(e.toString());
      setIsSubmittingPlaca(false);
    }
  };

  const onlyNumbers = (value) => {
    return value.replace(/[^\d]/g, '');
  }

  const toLowerCase = (value) => {
    return value.toLowerCase();
  }

  const handleSetUfEmissaoValue = (value) => {
    const _ufEmissaoValue = optionsUf.find(uf => uf.value === value);
    setUfEmissaoValue(_ufEmissaoValue);
  }

  useEffect(() => {
    handleSetOptionsNumeroViaCrv();
    if (values.ano_fabricacao) {
      const _anoFabricacaoValue = { label: values.ano_fabricacao, value: values.ano_fabricacao };
      setAnoFabricacaoValue(_anoFabricacaoValue);
    }

    if (values.ano_modelo) {
      const _anoModeloValue = { label: values.ano_modelo, value: values.ano_modelo };
      setAnoModeloValue(_anoModeloValue);
    }

    if (values.uf_emissao) {
      handleSetUfEmissaoValue(values.uf_emissao);
    }

    if (values.data_emissao_crv) {
      const dataEmissaoCrv = typeof values.data_emissao_crv === 'object' ? values.data_emissao_crv.format("DD/MM/YYYY") : values.data_emissao_crv;
      setDataEmissaoValue(dataEmissaoCrv);
    }

    if (values.numero_via_crv) {
      const _numeroViaCrvValue = { label: values.numero_via_crv, value: values.numero_via_crv };
      setNumeroViaCrvValue(_numeroViaCrvValue);
    }

    setFormData({
      placa: values.placa,
      renavam: values.renavam,
      ano_fabricacao: values.ano_fabricacao,
      ano_modelo: values.ano_modelo,
      numero_crv: values.numero_crv,
      uf_emissao: values.uf_emissao,
      data_emissao_crv: values.data_emissao_crv,
      numero_via_crv: values.numero_via_crv,
      codigo_seguranca_crv: values.codigo_seguranca_crv,
      nome_proprietario: values.nome_proprietario,
      numero_identificacao_proprietario: values.numero_identificacao_proprietario,
      email_proprietario: values.email_proprietario,
      telefone_proprietario: values.telefone_proprietario
    });
  }, [values])

  const [formData, setFormData] = useState({
    placa: '',
    renavam: '',
    ano_fabricacao: '',
    ano_modelo: '',
    numero_crv: '',
    uf_emissao: '',
    data_emissao_crv: '',
    numero_via_crv: '',
    codigo_seguranca_crv: '',
    nome_proprietario: '',
    numero_identificacao_proprietario: '',
    email_proprietario: '',
    telefone_proprietario: '',
  });

  const [errors, setErrors] = useState({
    placa: '',
    renavam: '',
    ano_fabricacao: '',
    ano_modelo: '',
    numero_crv: '',
    uf_emissao: '',
    data_emissao_crv: '',
    numero_via_crv: '',
    codigo_seguranca_crv: '',
    nome_proprietario: '',
    numero_identificacao_proprietario: '',
    email_proprietario: '',
    telefone_proprietario: ''
  });

  const setFieldValue = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Fragment>
      <Card className="border-custom">
        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Veículo</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <Label htmlFor="placa"><span className="text-danger">***</span> Placa</Label>
              <InputGroup>
                <Input
                  type="text"
                  name="placa"
                  id="placa"
                  placeholder="Digite a Placa"
                  onChange={(e) => setFieldValue('placa', e.target.value)}
                  value={formData.placa}
                  className={"form-control" + (errors.placa ? " is-invalid" : "")}
                />
                <InputGroupAddon addonType="append">
                <Button type="button" color="primary" onClick={() => getDados()} disabled={!formData.placa || isSubmittingPlaca}>
                  {isSubmittingPlaca ? <Spinner color="light" size="sm" className="mr-1" /> : <i className="fa-solid fa-magnifying-glass"></i>}
                </Button>
                </InputGroupAddon>
                <div className="invalid-feedback">{errors.placa}</div>
              </InputGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="renavam"><span className="text-danger">***</span> Renavam</Label>
                <Input
                  type="text"
                  name="renavam"
                  id="renavam"
                  placeholder="Digite o Renavam"
                  onChange={(e) => setFieldValue('renavam', e.target.value)}
                  onKeyUp={(e) => setFieldValue('renavam', onlyNumbers(e.target.value))}
                  value={isSubmittingPlaca ? "..." : formData.renavam}
                  className={"form-control" + (errors.renavam ? " is-invalid" : "")}
                  disabled={isSubmittingPlaca}
                  maxLength={11}
                />
                <div className="invalid-feedback">{errors.renavam}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="ano_fabricacao"><span className="text-danger">***</span> Ano Fabricação</Label>
                <SelectAno
                  name="ano_fabricacao"
                  id="ano_fabricacao"
                  placeholder={isSubmittingPlaca ? "..." : "Selecione o Ano de Fabricação"}
                  className={errors.ano_fabricacao ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("ano_fabricacao", data ? data.value : ""); setAnoFabricacaoValue({label: data.value, value: data.value }) }}
                  isSearchable={true}
                  isClearable={true}
                  value={anoFabricacaoValue}
                  disabled={isSubmittingPlaca}
                />
                <div className="invalid-feedback">{errors.ano_fabricacao}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="ano_modelo"><span className="text-danger">***</span> Ano Modelo</Label>
                <SelectAno
                  name="ano_modelo"
                  id="ano_modelo"
                  placeholder={isSubmittingPlaca ? "..." : "Selecione o Ano de Fabricação"}
                  className={errors.ano_modelo ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("ano_modelo", data ? data.value : ""); setAnoModeloValue({label: data.value, value: data.value }) }}
                  isSearchable={true}
                  isClearable={true}
                  value={anoModeloValue}
                  ultimoAno={new Date().getFullYear() + 1}
                  disabled={isSubmittingPlaca}
                />
                <div className="invalid-feedback">{errors.ano_modelo}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero_crv"><span className="text-danger">***</span> Número Crv</Label>
                <Input
                  type="text"
                  name="numero_crv"
                  id="numero_crv"
                  placeholder="Digite o Número Crv"
                  onChange={(e) => setFieldValue('numero_crv', e.target.value)}
                  onKeyUp={(e) => setFieldValue('numero_crv', onlyNumbers(e.target.value))}
                  value={formData.numero_crv}
                  className={"form-control" + (errors.numero_crv ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.numero_crv}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="uf_emissao"><span className="text-danger">***</span> UF Emissão Crv</Label>
                <SelectUf
                  name="uf_emissao"
                  id="uf_emissao"
                  placeholder="Selecione a UF de Emissão do Crv"
                  className={errors.uf_emissao ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("uf_emissao", data ? data.value : ""); handleSetUfEmissaoValue(data.value) }}
                  isSearchable={true}
                  isClearable={true}
                  value={ufEmissaoValue}
                />
                <div className="invalid-feedback">{errors.uf_emissao}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="data_emissao_crv"><span className="text-danger">***</span> Data Emissão Crv</Label>
                <Datetime
                  id="data_emissao_crv"
                  name="data_emissao_crv"
                  locale="pt-br"
                  value={dataEmissaoValue}
                  timeFormat={false}
                  closeOnSelect={true}
                  closeOnClickOutside={true}
                  renderInput={renderInputDatePicker}
                  onChange={(date) => { setFieldValue("data_emissao_crv", date) }}
                  className={(errors.data_emissao_crv ? "is-invalid invalid-multi-select" : "")}
                />
                <div className="invalid-feedback">{errors.data_emissao_crv}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero_via_crv"><span className="text-danger">***</span> Número da Via do Crv</Label>
                <Select
                  name="numero_via_crv"
                  id="numero_via_crv"
                  placeholder="Selecione o Número da Via do Crv"
                  className={errors.numero_via_crv ? "is-invalid invalid-multi-select" : ""}
                  onChange={(data) => { setFieldValue("numero_via_crv", data ? data.value : ""); setNumeroViaCrvValue({label: data.value, value: data.value }) }}
                  isSearchable={true}
                  isClearable={true}
                  value={numeroViaCrvValue}
                  components={{ Component }}
                  options={optionsNumeroViaCrv}
                />
                <div className="invalid-feedback">{errors.numero_via_crv}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="codigo_seguranca_crv"><span className="text-danger">***</span> Código Segurança Crv</Label>
                <Input
                  type="text"
                  name="codigo_seguranca_crv"
                  id="codigo_seguranca_crv"
                  placeholder="Digite o Código Segurança Crv"
                  onChange={(e) => setFieldValue('codigo_seguranca_crv', e.target.value)}
                  value={formData.codigo_seguranca_crv}
                  className={"form-control" + (errors.codigo_seguranca_crv ? " is-invalid" : "")}
                />
                <div className="invalid-feedback">{errors.codigo_seguranca_crv}</div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>

        <CardHeader className="card-custom">
          <CardTitle className="card-text-custom">Dados do Proprietário Atual</CardTitle>
        </CardHeader>
        <CardBody>
          <Row>
            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="numero_identificacao_proprietario"><span className="text-danger">***</span> CPF ou CNPJ</Label>
                <Input
                  type="text"
                  name="numero_identificacao_proprietario"
                  id="numero_identificacao_proprietario"
                  placeholder="Digite o CPF ou CNPJ"
                  className={"form-control" + (errors.numero_identificacao_proprietario ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('numero_identificacao_proprietario', cpfCnpjMask(e.target.value))}
                  value={isSubmittingPlaca ? "..." : formData.numero_identificacao_proprietario}
                  maxLength="18"
                  disabled={isSubmittingPlaca}
                />
                <div className="invalid-feedback">{errors.numero_identificacao_proprietario}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="nome_proprietario"><span className="text-danger">***</span> Nome</Label>
                <Input
                  type="text"
                  name="nome_proprietario"
                  id="nome_proprietario"
                  placeholder="Digite o Nome"
                  className={"form-control" + (errors.nome_proprietario ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('nome_proprietario', e.target.value)}
                  value={isSubmittingPlaca ? "..." : formData.nome_proprietario}
                  disabled={isSubmittingPlaca}
                />
                <div className="invalid-feedback">{errors.nome_proprietario}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="email_proprietario"><span className="text-danger">***</span> Email</Label>
                <Input
                  type="text"
                  name="email_proprietario"
                  id="email_proprietario"
                  placeholder="Digite o Email"
                  className={"form-control" + (errors.email_proprietario ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('email_proprietario', e.target.value)}
                  onKeyUp={(e) => setFieldValue('email_proprietario', toLowerCase(e.target.value))}
                  value={formData.email_proprietario}
                />
                <div className="invalid-feedback">{errors.email_proprietario}</div>
              </FormGroup>
            </Col>

            <Col sm="6" md="4">
              <FormGroup>
                <Label htmlFor="telefone_proprietario">Telefone</Label>
                <Input
                  type="text"
                  name="telefone_proprietario"
                  id="telefone_proprietario"
                  placeholder="Digite o Telefone"
                  className={"form-control" + (errors.telefone_proprietario ? " is-invalid" : "")}
                  onChange={(e) => setFieldValue('telefone_proprietario', phoneMask(e.target.value))}
                  value={formData.telefone_proprietario}
                  maxLength={15}
                />
                <div className="invalid-feedback">{errors.telefone_proprietario}</div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div className="text-center">
        <Button className="mr-1" color="primary" onClick={validate}>Próximo</Button>
      </div>
    </Fragment>
  );
};

export default Step1;